import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link, useLocation } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const CURRENCY = "USD";

const generateOrderNo = () => {
  const randomValues = new Uint32Array(2);

  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(randomValues);
  } else {
    randomValues[0] = Math.floor(Math.random() * 1_000_000_000);
    randomValues[1] = Math.floor(Math.random() * 1_000_000_000);
  }

  const randomPart = Array.from(randomValues)
    .map((value) => value.toString().padStart(10, "0"))
    .join("")
    .slice(0, 14);

  return `${Date.now()}${randomPart}`;
};

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [contact, setContact] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState({});

  const location = useLocation();
  const { sub } = location.state || {};

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      if (!product) return total;

      const price = Number.parseFloat(String(product.price).replace(/,/g, ""));
      return total + price * item.quantity;
    }, 0);
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();

    const trimmedEmail = contact.trim();
    const newErrors = {};

    if (!/^\S+@\S+\.\S+$/.test(trimmedEmail)) {
      newErrors.contact = "Enter a valid email address";
    }
    if (!countryCode) newErrors.countryCode = "Select a country";
    if (!firstName.trim()) newErrors.firstName = "Enter a first name";
    if (!lastName.trim()) newErrors.lastName = "Enter a last name";
    if (!address.trim()) newErrors.address = "Enter an address";
    if (!city.trim()) newErrors.city = "Enter a city";
    if (!postalCode.trim()) {
      newErrors.postalCode = "Enter a ZIP / postal code";
    }
    if (cartItems.length === 0) {
      newErrors.cart = "Your cart is empty";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const firstProduct = getProductById(cartItems[0].id);
    if (!firstProduct) {
      setErrors({ cart: "The first product in your cart is unavailable" });
      return;
    }

    const paymentResultUrl = new URL("/payment", window.location.origin);
    const paymentUrl = new URL("/create_payment.php", window.location.origin);

    paymentUrl.search = new URLSearchParams({
      orderNo: generateOrderNo(),
      amount: calculateTotal().toFixed(2),
      currency: CURRENCY,
      email: trimmedEmail,
      success_url: `${paymentResultUrl.toString()}?state=success`,
      cancel_url: `${paymentResultUrl.toString()}?state=cancel`,
      title: firstProduct.name,
    }).toString();

    window.location.assign(paymentUrl.toString());
  };

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      id="ban-do-we-exist-to-help-you-be-your-best"
      className="main-containerCheck template-index theme-animate-hover"
    >
      <div className="check-custom-checkout-page">
        <div className="left">
          <div className="check-order-info">
            <form onSubmit={handlePlaceOrder} noValidate>
              <div className="form-group">
                <label htmlFor="contact">Contact</label>
                <input
                  type="email"
                  id="contact"
                  name="contact"
                  value={contact}
                  placeholder="Email address"
                  onChange={(event) => setContact(event.target.value)}
                  autoComplete="email"
                  aria-invalid={Boolean(errors.contact)}
                />
                {errors.contact && <p className="error">{errors.contact}</p>}
              </div>

              <div className="form-group">
                <label>Delivery</label>
                <ReactFlagsSelect
                  selected={countryCode}
                  onSelect={(code) => setCountryCode(code)}
                  className={errors.countryCode ? "check-select has-error" : "check-select"}
                  searchable
                />
                {errors.countryCode && (
                  <p className="error">{errors.countryCode}</p>
                )}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    placeholder="First name *"
                    onChange={(event) => setFirstName(event.target.value)}
                    autoComplete="given-name"
                    aria-invalid={Boolean(errors.firstName)}
                  />
                  {errors.firstName && <p className="error">{errors.firstName}</p>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={lastName}
                    placeholder="Last name *"
                    onChange={(event) => setLastName(event.target.value)}
                    autoComplete="family-name"
                    aria-invalid={Boolean(errors.lastName)}
                  />
                  {errors.lastName && <p className="error">{errors.lastName}</p>}
                </div>
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="company-name"
                  name="company-name"
                  value={company}
                  onChange={(event) => setCompany(event.target.value)}
                  placeholder="Company name (optional)"
                  autoComplete="organization"
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={address}
                  onChange={(event) => setAddress(event.target.value)}
                  placeholder="Address"
                  autoComplete="address-line1"
                  aria-invalid={Boolean(errors.address)}
                />
                {errors.address && <p className="error">{errors.address}</p>}
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="address1"
                  name="address1"
                  value={address1}
                  onChange={(event) => setAddress1(event.target.value)}
                  placeholder="Apartment, suite, etc. (optional)"
                  autoComplete="address-line2"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={city}
                    placeholder="City"
                    onChange={(event) => setCity(event.target.value)}
                    autoComplete="address-level2"
                    aria-invalid={Boolean(errors.city)}
                  />
                  {errors.city && <p className="error">{errors.city}</p>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="postalCode"
                    name="postalCode"
                    value={postalCode}
                    placeholder="Postal code"
                    onChange={(event) => setPostalCode(event.target.value)}
                    autoComplete="postal-code"
                    aria-invalid={Boolean(errors.postalCode)}
                  />
                  {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                </div>
              </div>

              {errors.cart && <p className="checkout-form-error">{errors.cart}</p>}

              <button type="submit" className="check-checkout-button">
                Pay Now
              </button>
            </form>

            <p>
              <Link
                to="/returns"
                style={{ textDecoration: "underline" }}
                onClick={toTop}
              >
                Shipping & Returns Info
              </Link>
            </p>
          </div>
        </div>

        {!sub && (
          <div className="right">
            <div className="check-order-summary">
              <div className="check-order-details">
                {cartItems.map((item, index) => {
                  const product = getProductById(item.id);
                  if (!product || !product.images) return null;
                  return (
                    <div key={`${item.id}-${item.size}-${item.color}-${index}`} className="check-cart-item">
                      <img
                        src={`/generated/checkout/${product.id}.jpg`}
                        alt={product.name}
                      />
                      <div className="pro--qty">
                        <div className="qty-inner">{item.quantity}</div>
                      </div>
                      <div className="check-item-details">
                        <h3>
                          {product.name}
                          {item.size && <><br />Size: {item.size}</>}
                          {item.color && <><br />Color: {item.color}</>}
                        </h3>
                      </div>
                      <p className="cal-single">${product.price}</p>
                    </div>
                  );
                })}

                <div className="check-summary-details">
                  <div className="gridTotal">
                    <table className="summary-details22">
                      <tbody className="sumTbody22">
                        <tr className="sumTr22">
                          <th className="subtotalTh22" style={{ fontSize: "24px" }}>
                            Total
                          </th>
                          <th className="subtotalTxt22">
                            ${calculateTotal().toFixed(2)} {CURRENCY}
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckOut;
